module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-select', {
    class: {
      'placeholder-not-showing': !_vm.showPlaceholder,
      'custom-select': true,
      'vue-select': true,
      'vue-select__disabled': _vm.isDisabled,
      'vue-select__medium': _vm.isMedium
    },
    attrs: {
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "value": _vm.fullValue,
      "multiple": false,
      "clear-on-select": false,
      "hide-selected": true,
      "label": _vm.label,
      "track-by": "name",
      "debounce": 250,
      "disabled": _vm.isDisabled,
      "on-search": _vm.searchOptions,
      "loading": _vm.loading,
      "clearable": _vm.isClearable,
      "noDrop": _vm.options.length === 1 || !_vm.clearable
    },
    on: {
      "input": _vm.emitInput,
      "search:focus": _vm.checkPosition,
      "search:blur": _vm.clearOptionsIfEmpty
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eef79f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/dropDownList/StyledSelectVModel.vue
// module id = 1941
// module chunks = 0